import './qr.component.scss';

import { Component } from 'preact';
import qrcode from 'qrcode-generator';

interface QRProps {
  text: string;
}

export class QRComponent extends Component<QRProps> {
  private containerRef: HTMLDivElement | null = null;

  componentDidMount(): void {
    this.renderQRCode();
  }

  componentDidUpdate(prevProps: QRProps): void {
    if (prevProps.text !== this.props.text) {
      this.renderQRCode();
    }
  }

  private renderQRCode(): void {
    const { text } = this.props;

    const qr = qrcode(0, 'H');
    qr.addData(text);
    qr.make();
    const svgMarkup = qr.createSvgTag({ scalable: true });

    if (this.containerRef) {
      this.containerRef.innerHTML = '';
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgMarkup, 'image/svg+xml');
      this.containerRef.appendChild(svgDoc.documentElement);
    }
  }

  render() {
    return <div className="qrcode" ref={(el: HTMLDivElement | null) => (this.containerRef = el)} />;
  }
}
